import { FC, useContext } from 'react'
import { useElementRect } from '../../hooks/useElementRect'
import { TimelineTicks } from './TimelineTicks'
import './Timeline.scss'
import { InternalContext } from '../contexts/InternalContext'
import { TimelineSelection } from './TimelineSelection'
import { MousePosition } from '../components/MousePosition'
import { TimelineLabel } from './TimelineLabel'
import { PlaybackPosition } from '../components/PlaybackPosition'

export const Timeline: FC = () => {
  const { timelineElement, setTimelineElement, internalSelection } = useContext(InternalContext)
  const rect = useElementRect(timelineElement)

  return (
    <div className="Timeline">
      <div className="content" ref={setTimelineElement}>
        {rect && <TimelineTicks containerRect={rect} />}

        {internalSelection && <TimelineSelection internalSelection={internalSelection} />}

        <PlaybackPosition render={(props) => <TimelineLabel color="blue" {...props} />} time={true} />

        <MousePosition render={(props) => <TimelineLabel {...props} />} time={true} />
      </div>
    </div>
  )
}
